import { FAQProps } from "_components/FAQs/FAQs";

export const portfolioFAQs: FAQProps["items"] = [
  {
    title: "What information do I need to provide to set up my LaborPass?",
    body: "Personal, contact and work information",
  },
  {
    title: "How do I share my LaborPass with clients?",
    body: "Yes, you can upload both photos and videos of your completed projects. This helps potential clients see the quality of your work and makes your profile more engaging.",
  },
  {
    title: "How do I share my LaborPass with clients?",
    body: "Once your LaborPass is created, you will have a unique link. You can share this link via WhatsApp, email, or social media platforms to reach potential clients.",
  },
  {
    title: "Can I update my LaborPass after it's created?",
    body: "Yes, you can update your LaborPass anytime. Add new certifications, completed jobs, or LaborPass items to keep your profile current and appealing to clients.",
  },
];
